
const _getGlobalObject = () => {
	if ( typeof window !== 'undefined' && typeof window.GlobalClass !== 'undefined' && window.GlobalClass ) {
		var _GlobalClass = window.GlobalClass;
	}
	else if (typeof window !== 'undefined') {
		var _GlobalClass = ( window && window.simplestore && window.simplestore.Global ? window.simplestore.Global : null);
	}
	else if (typeof global !== 'undefined') {
		// we are in node js
		var _GlobalClass = ( global && global.simplestore && global.simplestore.Global ? global.simplestore.Global : null);
	}

	if (_GlobalClass)
	return _GlobalClass.getGlobalObject();
};


const getMvcMyDashboard = async () => {
	const Model = require('../../model.js');

	//const model = Model.getObject(); //  does not work in webpack (TypeError: "exports" is read-only)
	const _global = _getGlobalObject();
	if (!_global) return;
	const model = _global.getModuleObject('mydashboard-model');

	const mvcmydashboard = await model.getMvcMyDashboard();

	return mvcmydashboard;
};

export default {
	login: async ({ username, password }) => {
		const mvcmydashboard = await getMvcMyDashboard();

		if (!mvcmydashboard) return Promise.resolve();

		let sessionuuid = await mvcmydashboard.getCurrentSession();

		return mvcmydashboard.authenticateSession(sessionuuid, username, password);
	},
   logout: async () => {
		const mvcmydashboard = await getMvcMyDashboard();

		if (!mvcmydashboard) return Promise.resolve();

		let sessionuuid = await mvcmydashboard.getCurrentSession();

		mvcmydashboard.logoutSession(sessionuuid)

		return Promise.resolve();
	},
	checkError: async ({ status }) => {
		const mvcmydashboard = await getMvcMyDashboard();

		if (!mvcmydashboard) return Promise.resolve();

		let sessionuuid = await mvcmydashboard.getCurrentSession();

		if (!sessionuuid) {
			return Promise.reject();
		}
		return Promise.resolve();
	},
	checkAuth: async () => {
		const mvcmydashboard = await getMvcMyDashboard();

		if (!mvcmydashboard) return Promise.resolve();

		let sessionuuid = await mvcmydashboard.getCurrentSession();

		let isAnonymous = await mvcmydashboard.isAnonymousSession(sessionuuid);

		return isAnonymous !== true
			? Promise.resolve()
			: Promise.reject();
	},
	getPermissions: async  () => Promise.resolve(),
 };